import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { processJSXContent } from '@common/utils/blogHyperlinks';

function Impact() {

  return (
    <div className='bs-impact'>
        <div className='bs-impact__head-wrap'>
            <div className='bs-impact__title-wrap'>
                <h2 className='bs-impact__title'>the positive impact</h2>
                <p className='bs-impact__desc' dangerouslySetInnerHTML={processJSXContent('Popular eco-conscious fabrics include organic cotton, which is grown without harmful chemicals and offers a soft, breathable texture ideal for upholstery and curtains. Linen, made from flax, is biodegradable and provides a light, airy feel. Recycled polyester, spun into yarn from repurposed plastic waste, creates durable and sleek fabrics like Locomotion, Earthen, and Satina. Explore all our <span className="cm-bold">sustainable yarn</span> collections.')}></p>
            </div>
            <div className='bs-impact__media-wrap'>
                <CloudinaryAdvancedImage imagePublicId="blog-1" className='bs-impact__image' type="blog-thumbnail-card" />
                <a href="/collection-detail/earthen" className='bs-impact__media-title-wrap'>
                    <label className='bs-impact__media-title'>EARTHEN - SUSTAINABLE MULTIPURPOSE PLAINS</label>
                </a>
            </div>
        </div>
        <div className='bs-impact__cont-wrap'>
            <ul className='bs-impact__media-list'>
                <li className='bs-impact__media-item'>
                    <CloudinaryAdvancedImage imagePublicId="blog-2" className='bs-impact__media-item-image' type="blog-thumbnail-card" />
                </li>
                <li className='bs-impact__media-item'>
                    <CloudinaryAdvancedImage imagePublicId="blog-3" className='bs-impact__media-item-image' type="blog-thumbnail-card" />
                </li>
                <li className='bs-impact__media-item'>
                    <CloudinaryAdvancedImage imagePublicId="blog-4" className='bs-impact__media-item-image' type="blog-thumbnail-card" />
                </li>
            </ul>
            <div className='bs-impact__more-info'>
                <p className='bs-impact__desc' dangerouslySetInnerHTML={processJSXContent('In a world increasingly defined by conscious choices, creating an eco-friendly yet elegant home is more attainable than ever with Sansaar. By incorporating our exquisite collections like Melange, Mystique, and Tundra Boucle featuring timeless elements, diverse color palette, and natural textures, you can cultivate a space that not only serves as a mindful choice but also adds a contemporary touch to it. Transform your home into a sanctuary of beauty and sustainability, where every detail contributes to a greener future.')}></p>
                <strong className='bs-impact__author'>With Sansaar, design and conscience coexist beautifully.</strong>
            </div>
        </div>
    </div>
  )
}

export default Impact